import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EncryptionUtilityPanel from "components/EncryptionUtilityPanel";

interface EncryptionUtilityModalProps {
  open: boolean;
  onClose: () => void;
}

const EncryptionUtilityModal = ({ open, onClose }: EncryptionUtilityModalProps) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      Encryption Utility
      <IconButton size="small" onClick={onClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <EncryptionUtilityPanel />
    </DialogContent>
  </Dialog>
);

export default EncryptionUtilityModal;
